import { createAction, props } from '@ngrx/store';
import { Announcements } from '@app/core/async-services/http/versioned/interfaces';
import { API } from '@app/core/models';
import { ChannelData } from '@app/core/async-services/http/versioned/interfaces/chat.interface';

export const loadHotels = createAction('[Announcement] Load Hotels');

export const loadHotelsSuccess = createAction(
  '[Announcement] Load Hotels Success',
  props<{ response: Announcements.HotelsResponse }>(),
);

export const loadHotelsFailure = createAction(
  '[Announcement] Load Hotels Failure',
  props<{ response: Announcements.HotelsResponse }>(),
);

export const loadManagers = createAction('[Announcement] Load Managers');

export const loadManagersSuccess = createAction(
  '[Announcement] Load Managers Success',
  props<{ response: Announcements.ManagersResponse }>(),
);

export const loadManagersFailure = createAction(
  '[Announcement] Load Managers Failure',
  props<{ response: Announcements.ManagersResponse }>(),
);

export const addHotelRecipient = createAction(
  '[Announcement] Add Hotel Recipient',
  props<{ id: string }>(),
);

export const addDepartmentRecipient = createAction(
  '[Announcement] Add Department Recipient',
  props<{ id: string }>(),
);

export const addHotelManagerRecipient = createAction(
  '[Announcement] Add Hotel Manager Recipient',
  props<{ id: string }>(),
);

export const addCorporateManagerRecipient = createAction(
  '[Announcement] Add Corporate Manager Recipient',
  props<{ id: string }>(),
);

export const removeRecipient = createAction(
  '[Announcement] Remove Recipient',
  props<{ index: number }>(),
);

export const clearRecipients = createAction('[Announcement] Clear Recipients');

export const clearRecipientsAndDraft = createAction(
  '[Announcement] Clear Recipients and Draft Message',
);

export const addAllEmployees = createAction('[Announcement] Add All Employees');

export const addAllHotelManagers = createAction(
  '[Announcement] Add All Hotel Managers',
);

export const addAllCorporateManagers = createAction(
  '[Announcement] Add All Corporate Managers',
);

export const loadExistingAnnouncement = createAction(
  '[Announcement] Load existing announcement',
  props<{ channelId: string }>(),
);

export const loadExistingAnnouncementSuccess = createAction(
  '[Announcement] Load existing announcement success',
  props<{ payload: ChannelData }>(),
);

export const loadExistingAnnouncementFailure = createAction(
  '[Announcement] Load existing announcement failure',
  props<API.Response>(),
);

export const resetViewAnnouncementState = createAction(
  '[Announcement] Reset announcement state',
);

export const saveAnnouncementDraft = createAction(
  '[Announcement] Save announcement draft',
  props<{ announcementDraft: string }>(),
);
